import { isNucleusWorkflowsEnabled } from "./nucleusWorkflowsGate";

export { isNucleusWorkflowsEnabled };

export const nucleusWorkflowsEnabled = isNucleusWorkflowsEnabled({
  DEV: import.meta.env.DEV,
  VITE_ENABLE_NUCLEUS_WORKFLOWS: import.meta.env.VITE_ENABLE_NUCLEUS_WORKFLOWS,
});
